import React, { useContext, useState } from "react";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoMdMail } from "react-icons/io";

export default function WelcomePage() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [setshowOtp, setSetshowOtp] = useState(false);

  const navigate = useNavigate();

  const Handle_Login = () => {
    setIsLoading(true);

    try {
      axios
        .post(
          BASE_URL + "send_login_otp.php",
          {
            reg_em: email,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            toast.success(acc.data.message);
            setSetshowOtp(true);
          }
        })
        .catch((err) => {
          setIsLoading(false);

          console.log(err);
        });
    } catch (error) {
      setIsLoading(false);

      console.log(error);
    }
  };

  const Handle_Enter_OTP = () => {
    setIsLoading(true);

    try {
      axios
        .post(
          BASE_URL + "verify_login_otp.php",
          {
            reg_em: email,
            otp: otp,
            ip_addr: window.localStorage.getItem("bpipos")
              ? window.localStorage.getItem("bpipos")
              : "224.234.50.218",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);

          setIsLoading(false);

          if (acc.data.status == "FAILED") {
            toast.error(acc.data.message);
          } else {
            toast.success(acc.data.message);

            localStorage.setItem("jwt", JSON.stringify(acc.data.data));
            navigate("/");
          }
        })
        .catch((err) => {
          setIsLoading(false);

          console.log(err);
        });
    } catch (error) {
      setIsLoading(false);

      console.log(error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <ToastContainer />
      <div
        className="position-relative w-100 h-100 overflow-hidden shadow-md"
        style={{
          backgroundImage:
            "linear-gradient(rgb(255, 193, 7) 0%, rgb(222 159 64) 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
        }}
      >
        {/* Background images */}

        {/* Overlay */}
        {/* <div className="position-absolute w-100 h-100 bg-transparent"></div> */}
        <img
          src="/logo.png"
          alt="boss panda"
          className="align-self-center mb-3"
          width={230}
          height={230}
        />
        <h1 style={{ marginBottom: "20px", color: "white" }}>
          Welcome to BossPanda
        </h1>

        <p style={{ maxWidth: "500px", marginBottom: "2px", color: "black" }}>
          Congratulations!
        </p>
        <p style={{ maxWidth: "500px", marginBottom: "2px", color: "black" }}>
          You have successfully registered with BOSS PANDA.
        </p>
        <p style={{ maxWidth: "500px", marginBottom: "2px", color: "black" }}>
          Your Invitation Code is sent to your e-mail I'd.
        </p>
        <p style={{ maxWidth: "500px", marginBottom: "2px", color: "black" }}>
          Use your Invitation Code to invite your friends and family members and
          start earning more BOSS PANDA REWARDS.
        </p>

        <div style={{ display: "flex", gap: "10px", marginTop: "25px" }}>
          <ButtonComponent
            handleClick={() => navigate("/login")}
            className="mc-btn primary"
            icon="login"
            text={"Login"}
            style={{
              background: "black",
              color: "yellow",
            }}
          />

          <ButtonComponent
            handleClick={() =>
              window.location.replace("https://bosspanda.io/")
            }
            className="mc-btn primary"
            icon="home"
            text={"Home"}
            style={{
              background: "black",
              color: "yellow",
            }}
          />
        </div>
      </div>
    </div>
  );
}
